import './polyfills'

import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import TagManager from 'react-gtm-module'
import getAuth0ClientConfig from './lib/auth0/get-auth0-client-config'
import Auth0ClientConfigContext from './lib/auth0/auth0-client-config-context'
import AnalyticsContext from './lib/analytics/context'
import LoggerContext from './lib/logger/context'
import consoleAnalytics from './lib/analytics/console'
import gtmAnalytics from './lib/analytics'
import consoleLogger from './lib/logger/console'
import sentryLogger from './lib/logger'
import App from './App'
import Favicons from './components/favicons'
import ErrorPage from './pages/error'
import TaskHeader from './pages/layout/task-header'

const isSentryEnabled = Boolean(process.env.REACT_APP_SENTRY_DSN)
const logger = isSentryEnabled ? sentryLogger : consoleLogger

if (isSentryEnabled) {
  Sentry.init({
    debug: true,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
  })
}

let auth0ClientConfig = null
try {
  auth0ClientConfig = getAuth0ClientConfig(window.auth0Config.clientID)
} catch (error) {
  logger.captureException(error)
}

const isGtmEnabled = Boolean(process.env.REACT_APP_GTM_ID)
const analytics = isGtmEnabled ? gtmAnalytics : consoleAnalytics

if (isGtmEnabled && process.env.REACT_APP_GTM_ID) {
  const gtmPreviewArgs =
    process.env.REACT_APP_GTM_PREVIEW_AUTH &&
    process.env.REACT_APP_GTM_PREVIEW_ENV
      ? {
          auth: process.env.REACT_APP_GTM_PREVIEW_AUTH,
          preview: process.env.REACT_APP_GTM_PREVIEW_ENV,
        }
      : {}
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    ...gtmPreviewArgs,
  })
}

const { extraParams } = window.auth0Config

const index = auth0ClientConfig ? (
  <>
    <Favicons pathToAssets={process.env.PUBLIC_URL} />
    <AnalyticsContext.Provider value={analytics}>
      <LoggerContext.Provider value={logger}>
        <Auth0ClientConfigContext.Provider value={auth0ClientConfig}>
          <App
            initialScreen={window.auth0Config.extraParams.screen_hint}
            initialNotificationFlags={{
              sessionExpired: extraParams.westfield_session_expired === 'true',
              passwordResetExpired:
                extraParams.westfield_password_reset_expired === 'true',
              passwordResetSuccess:
                extraParams.westfield_password_reset_success === 'true',
              userIsBlocked: extraParams.westfield_user_is_blocked === 'true',
              genericIssue: extraParams.westfield_generic_issue === 'true',
            }}
          />
        </Auth0ClientConfigContext.Provider>
      </LoggerContext.Provider>
    </AnalyticsContext.Provider>
  </>
) : (
  // We must *always* have the auth0 client config, so if in the very unlikely scenario we're unable to retrieve it,
  // something has gone horribly wrong, and in which case, present a very obvious error page
  <>
    <TaskHeader
      back={{ label: 'Back', handleClickBack: () => window.history.back() }}
    />
    <ErrorPage includeLinkToHome={false} />
  </>
)

ReactDOM.render(
  <React.StrictMode>{index}</React.StrictMode>,
  document.getElementById('root')
)
